export const salonFinderServer = {
    baseURL: 'https://sf-api.dailyvanity.sg/api-v2',
    wpURL: 'https://salonfinder.dailyvanity.sg',
    bucketURL: "https://sf-uploads.dailyvanity.sg",
    uploadBucket: "sf-uploads.dailyvanity.sg",
}
